import { render, staticRenderFns } from "./MyAccountPage.vue?vue&type=template&id=77526551&"
import script from "./MyAccountPage.vue?vue&type=script&lang=js&"
export * from "./MyAccountPage.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountPage.vue?vue&type=style&index=0&id=77526551&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports